module.exports = __webpack_public_path__ + "static/img/8.c5a0dc4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/zh/8.png
// module id = KLzu
// module chunks = 0